module.exports = __webpack_public_path__ + "static/media/supotsu_logo.37cd11ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/supotsu_logo.svg
// module id = 1787
// module chunks = 0